module.exports = __webpack_public_path__ + "img/检测业务流程.1083d883.png";